<template>

    <div>

        <div style="color: red" class="error-soc-no-email" v-show="registerStatus === registerStatuses.emailNotFilled">
            <div class="text error-registration-text">
                <div>В Вашем аккаунте соцсети не заполнен email.</div>
            </div>
        </div>

        <div style="color: red" class="error-soc-email-busy" v-show="registerStatus === registerStatuses.emailTaken">
            <div class="text error-registration-text">
                <div>Такой email уже зарегистрирован в системе.</div>
                <div>
                    Возможно, ранее Вы авторизовались через другую соцсеть.
                </div>
            </div>
        </div>

        <div class="error-soc-not-supported" style="color: red"
             v-show="registerStatus === registerStatuses.providerNotSupported">
            <div class="text error-registration-text">
                <div>Не поддерживается авторизация через данного провайдера.</div>
            </div>
        </div>

        <div style="color: red" v-show="registerStatus === registerStatuses.other">
            <div class="text error-registration-text">
                <div>{{ errorMessage }}</div>
            </div>
        </div>
    </div>

</template>

<script>
    import store from '@/store';


    const registerStatusesInternal = Object.freeze({
        waiting: 1,
        success: 2,
        emailNotFilled: 3,
        emailTaken: 4,
        providerNotSupported: 5,
        other: 6
    });

    export default {
        name: "OAuth2Result",


        data() {
            return {
                registerStatuses: registerStatusesInternal,
                registerStatus: registerStatusesInternal.waiting,
                errorMessage: null
            }
        },

        created() {
            this.saveToken()
        },

        methods: {
            async saveToken() {
                let socialToken = this.$route.query.socialToken;
                if (!!socialToken) {
                    await this.$store.dispatch('setSocialToken', socialToken);
                    let isAuthenticated = await store.dispatch('loadCurrentUserData');
                    if (isAuthenticated) {
                        this.registerStatus = this.registerStatuses.success;
                        store.dispatch('redirectAfterLogin');
                        return;
                    }
                }

                let errorCode = this.$route.query.errorCode;
                let error = this.$route.query.error;
                if (!!errorCode || !!error) {
                    switch (errorCode) {
                        case 'email_not_filled':
                            this.registerStatus = this.registerStatuses.emailNotFilled;
                            break;
                        case 'email_already_exists':
                            this.registerStatus = this.registerStatuses.emailTaken;
                            break;
                        case 'provider_not_supported':
                            this.registerStatus = this.registerStatuses.providerNotSupported;
                            break;
                        default:
                            this.errorMessage = 'Не удалось авторизоваться!';
                            this.registerStatus = this.registerStatuses.other;
                    }
                }

            }
        }
    }
</script>
